/*
* 门禁类型枚举
*/
export enum AccessControlType {
    GATE = 'Gate',           // 社区门禁
    MAIN_DOOR = 'MainDoor', // 楼门门禁
    SIDE_DOOR = 'SideDoor', // 侧门门禁
    GARAGE = 'Garage',       // 车库门禁
    ELEVATOR = 'Elevate',     // 电梯门禁
    PARCELSTOP = 'ParcelStop' //快递柜门禁


}